export default "__VITE_ASSET__CkGekmRG__"